import { render, staticRenderFns } from "./SysInfo.vue?vue&type=template&id=bf233494&scoped=true"
import script from "./SysInfo.vue?vue&type=script&lang=js"
export * from "./SysInfo.vue?vue&type=script&lang=js"
import style0 from "./SysInfo.vue?vue&type=style&index=0&id=bf233494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf233494",
  null
  
)

export default component.exports